class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelector('.buy')?.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('customization-product [type="submit"]')?.click();
    });
    this.querySelector('.customize')?.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
}

function initStickyAtcObserver() {
  const stickyAtc = document.querySelector('sticky-atc');
  if (!stickyAtc) return;

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      stickyAtc.classList.toggle('opacity-0', entry.isIntersecting);
    });
  }

  let options = {
    root: null,
    rootMargin: '-180px',
    threshold: 0,
  };
  let targetDiv = document.querySelector('ul[id^="Slider-Gallery-template-"]');
  if (window.innerWidth < 768) {
    options = {
      root: null,
      rootMargin: '-150px',
      threshold: 0,
    };
    targetDiv = document.querySelector('.product__info-wrapper');
  }

  if (targetDiv) {
    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(targetDiv);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAtcObserver);
} else {
  initStickyAtcObserver();
}

customElements.define('sticky-atc', StickyAtc);
